/** A primeira imagem de uma colagem ou de uma soltura, se houver. */
export const imageFileOf = (
  items: DataTransferItemList | null | undefined,
  files?: FileList | null
): File | null => {
  for (const item of Array.from(items ?? [])) {
    if (item.kind === 'file' && item.type.startsWith('image/')) {
      const file = item.getAsFile()
      if (file !== null) return file
    }
  }
  for (const file of Array.from(files ?? [])) {
    if (file.type.startsWith('image/')) return file
  }
  return null
}
